module.exports = __webpack_public_path__ + "static/media/2.727c447d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.svg
// module id = 846
// module chunks = 0